import React from "react";
import { TriyoForm } from "../../../../../components/TriyoForm";
import "./template-task-creation.scss";
import TemplateTaskCreationPanelFormMiddleUploadNew from "./template-task-creation-form-middle-upload-new";
import TemplateTaskCreationPanelFormMiddleCheckboxNew from "./template-task-creation-form-middle-checkbox-new";
import TemplateTaskCreationPanelFormMiddleRecurrenceNew from "./template-task-creation-form-middle-recurrence-new";
import TemplateTaskCreationPanelFormMiddleTopNew from "./template-task-creation-form-middle-top-new";
import PropTypes from "prop-types";

const TemplateTaskCreationPanelFormMiddleNew = ({
  isSubtask,
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  setFieldValue,
}) => {
  return (
    <div className="template-task-form-container">
      <div className="template-task-left-sub-panel">
        <TemplateTaskCreationPanelFormMiddleTopNew
          isSubtask={isSubtask}
          values={values}
          handleChange={handleChange}
          handleBlur={handleBlur}
          touched={touched}
          errors={errors}
          setFieldValue={setFieldValue}
        ></TemplateTaskCreationPanelFormMiddleTopNew>
        <TemplateTaskCreationPanelFormMiddleUploadNew
          values={values}
          setFieldValue={setFieldValue}
        ></TemplateTaskCreationPanelFormMiddleUploadNew>
      </div>

      <div className="template-task-right-sub-panel">
        {!isSubtask && (
          <TriyoForm>
            <TemplateTaskCreationPanelFormMiddleCheckboxNew
              values={values}
              setFieldValue={setFieldValue}
            ></TemplateTaskCreationPanelFormMiddleCheckboxNew>

            <TriyoForm.Divider />

            <TemplateTaskCreationPanelFormMiddleRecurrenceNew
              values={values}
              handleChange={handleChange}
              touched={touched}
              errors={errors}
              setFieldValue={setFieldValue}
            ></TemplateTaskCreationPanelFormMiddleRecurrenceNew>

            <TriyoForm.Divider />
          </TriyoForm>
        )}
      </div>
    </div>
  );
};

TemplateTaskCreationPanelFormMiddleNew.propTypes = {
  isSubtask: PropTypes.bool,
  values: PropTypes.object,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  touched: PropTypes.object,
  errors: PropTypes.object,
  setFieldValue: PropTypes.func,
};
export default TemplateTaskCreationPanelFormMiddleNew;
